window.Helpers = require('./helpers').Helpers;
require('./config');
window.$ = window.jQuery = require('jquery');
window.axios = require('axios');
// window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
require('./popper');
require('./bootstrap');
require('./perfect-scroll');
require('./select2');
require("flatpickr");
require('flatpickr/dist/l10n/pt');
require('./jquery.mask');
require('./jquery.maskMoney.min');
require('./jquery.printPage');
// require('./hammer');
// require('./typeahead');
// require('./i18n');
window.Menu = require('./menu').Menu;
require('./main');
require('./js');
